export default __webpack_public_path__ + "static/media/depositphotos_2.fdad4bbe.png";